import { z } from 'zod';

import {
  CursorPaginationMetaSchema,
  ListSortOrderSchema,
  PaginationSchema,
} from '../../pagination.js';

export const StockInventoryStatusSchema = z.enum(['DRAFT', 'IN_PROGRESS', 'COUNTED', 'FINALIZED']);

export type StockInventoryStatus = z.infer<typeof StockInventoryStatusSchema>;

export const StockInventoryStatusFilterSchema = z.enum([
  'all',
  'DRAFT',
  'IN_PROGRESS',
  'COUNTED',
  'FINALIZED',
]);

export type StockInventoryStatusFilter = z.infer<typeof StockInventoryStatusFilterSchema>;

export const ListStockInventoriesParamsSchema = z.object({
  placeId: z.uuid(),
});

export const StockInventoryListSortFieldSchema = z.enum([
  'displayNumber',
  'status',
  'cutoffAt',
  'progress',
  'storages',
  'updatedAt',
]);
export type StockInventoryListSortField = z.infer<typeof StockInventoryListSortFieldSchema>;

export const ListStockInventoriesQuerySchema = PaginationSchema.extend({
  q: z.preprocess(
    (val) => (typeof val === 'string' && val.trim() === '' ? undefined : val),
    z.string().trim().min(1).max(100).optional(),
  ),
  status: StockInventoryStatusFilterSchema.optional().default('all'),
  sort: StockInventoryListSortFieldSchema.optional(),
  order: ListSortOrderSchema.optional(),
});

export type ListStockInventoriesQuery = z.infer<typeof ListStockInventoriesQuerySchema>;

export const StockInventoryListItemSchema = z.object({
  id: z.uuid(),
  displayNumber: z.string(),
  status: StockInventoryStatusSchema,
  cutoffAt: z.iso.datetime(),
  totalLineCount: z.number().int().nonnegative(),
  countedLineCount: z.number().int().nonnegative(),
  storageScopeLabel: z.string(),
  updatedAt: z.iso.datetime(),
});

export type StockInventoryListItem = z.infer<typeof StockInventoryListItemSchema>;

export const ListStockInventoriesResponseSchema = z.object({
  items: z.array(StockInventoryListItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListStockInventoriesResponse = z.infer<typeof ListStockInventoriesResponseSchema>;

export const StockInventorySummaryParamsSchema = z.object({
  placeId: z.uuid(),
});

export const StockInventorySummaryResponseSchema = z.object({
  draftCount: z.number().int().nonnegative(),
  inProgressCount: z.number().int().nonnegative(),
  countedPendingFinalizeCount: z.number().int().nonnegative(),
  finalizedInPeriodCount: z.number().int().nonnegative(),
  finalizedPeriodDays: z.number().int().positive(),
});

export type StockInventorySummaryResponse = z.infer<typeof StockInventorySummaryResponseSchema>;
